import {createI18n} from 'vue-i18n';

const messages = {
  es: {
    global: {
      alert_info_title: 'Información!',
      placeholder_select: 'Seleccione',
      btn_filter: 'Filtrar',
      btn_clean: 'Limpiar',
      btn_compute: 'Calcular',
      btn_download: 'Descargar',
      btn_downloading: 'Descargando...',
      btn_search: 'Buscar',
      btn_searching: 'Buscando...',
      btn_save: 'Guardar',
      btn_cancel: 'Cancelar',
      pagination: {
        first: 'Primero',
        prev: 'Anterior',
        next: 'Siguiente',
        last: 'Último',
      }
    },
    header: {
      home: 'Inicio',
      signOut: 'Cerrar Sesión',
      signingOut: 'Cerrando sesión ...',
    },
    footer: {
      copyright: 'Todos los derechos reservados. Política de privacidad global.'
    },
    home: {
      title: 'Servicios',
      tdc: 'Herramienta TDC & SWAP',
      pricing_title: 'Precios'
    },
    tdc: {
      request_number: 'Número de Solicitud',
      market: 'Sales Office',
      countries: 'Source',
      sources: 'Source Point',
      divisions: 'División',
      categories: 'Categoría',
      subcategories: 'Subcategoría',
      families: 'Familia',
      formTypes: 'Tipo',
      sku: 'SKU',
      quantity: 'Quantity (MT)',
      creation_date: 'Fecha de Creación',
      created_by: 'Creado por',
      status: 'Status',
      users: 'Usuario',
      icp_kg: 'ICP / KG',
      export_charges: 'Export Charges',
      weight: 'Weight',
      carrier: 'Carrier',
      total_rate: 'Total Rate',
      product_cost_freight: 'Product Cost & Freight',
      porcent_import_duties: '% Import Duties',
      duties: 'Duties',
      in_land_in_country_rate: 'In-Land In Country Rate',
      duties_in_land_in_country: 'Duties and In-land in-country',
      tdc_act: 'TDC',
      comments: 'Comentarios',
      requests: {
        title: 'Consulta de Solicitudes',
        create: 'Crear nueva solicitud',
        approve: 'Aprobar solicitud',
        cancel: 'Cancelar solicitud',
      },
      details: {
        title: 'Detalles de Solicitud',
        not_found: 'El registro solicitado no fue encontrado.',
      },
      form: {
        title: 'Creación de Solicitud',
        subtitle: 'En esta sección puede crear una nueva solicitud',
        submitted: 'Tu solicitud fue registrada con éxito, es posible acompañar su status de aprobación desde la sección de "Consulta de Solicitudes".',
        validation: {
          select_single_choice: 'Debe seleccionar un',
          select_multiple_choice: 'Debe seleccionar al menos un',
          required_quantity: 'Debe ingresar una',
          select_multiple_requests: 'Debe seleccionar al menos un fila de la tabla.',
          required_comments: 'Debe agregar comentarios.',
        }
      },
      notified: 'Se ha notificado al perfil de aprobación correspondiente el estado de la solicitud.',
    },
    pricing: {
      mprecios: 'Mis precios',
      history: {
        title: "Histórico de Precios",
        help_txt_1: "En esta sección podrá revisar y descargar el histórico de precios.",
        help_txt_2: "",
        help_txt_3: "",
        id_distribuidor: "Id Cliente",
        client: "Cliente",
        plant: "Id Planta",
        plant_name: "Planta",
        sku_id: "Id Sku",
        sku: "Sku",
        start_date: "Fecha Desde",
        end_date: "Fecha Hasta",
        precio_usd_kg: "Precio USD/kg",
        precio_usuario: "Precio USD/lb",
        precio_usd_caja: "Precio USD/caja",
        upload_price_history: "Subir Histórico",
        tooltip: {
          upload_price_history: "Subir Archivo Histórico de Precios"
        },
        error: {
          file_fields_match: "Los campos del archivo no coinciden"
        }
      },
      competition: {
        title: "Precios de la Competencia",
        help_txt_1: "En esta sección puede visualizar los precios de la competencia.",
        help_txt_2: "Utilice los filtros de arriba para refinar su búsqueda.",
        help_txt_3: "También puede cargar nuevos precios de la competencia manualmente.",
        id: "Id",
        market: "Mercado",
        brand: "Marca",
        product: "Producto",
        sku_id: "ID de SKU",
        price_case_usd: "Precio por Caja (USD)",
        price_kg_usd: "Precio por Kg (USD)",
        price_pound_usd: "Precio por Libra (USD)",
        mccain_product: "Producto McCain",
        mccain_description: "Descripción McCain",
        upload_price: "Subir Precios",
        import_date: "Fecha de Carga",
        category: "Categoría",
        upload: {
          error_headers: "Los encabezados son inválidos. Verifique que el encabezado de su archivo Excel tenga el siguiente formato (separado por comas):"
        }
      },
      nprecio: 'Nuevo precio',
      mis_precios: {
        title: 'Mis precios',
        subtitle: 'Precios',
        dist: 'Distribuidor',
        ndist: 'Nombre Distribuidor',
        plant: 'Planta',
        startDate: 'Fecha Inicio',
        endDate: 'Fecha Fin',
        creationDate: 'Fecha Creación',
        priceCoordApprovalDate: 'Fecha Aprobación Price Coordinator',
        vendor: 'Vendedor',
        incoterm: 'Incoterm',
        invoice: 'Invoice Mode',
        state: 'Estado',
        profit: 'Validación Profit',
        ant: 'Anterior',
        sig: 'Siguiente',
        fleteLb: 'Flete Por Lb',
        fleteKg: 'Flete Por Kg',
        delivery: 'Delivery',
        codSap: 'CÓDIGO SAP',
        sku: 'SKU',
        precioUsdKg: 'PRECIO (USD/KG)',
        precioUsdCaja: 'PRECIO (USD/CAJA)',
        costoKg: 'COSTO KG',
        costoEnvioKg: 'COSTO ENVÍO KG',
        costoTotalKg: 'COSTO TOTAL KG',
        profitMin: 'PROFIT MÍNIMO (%)',
        profitCal1: 'PROFIT CALCULADO (%)',
        profitCal2: 'PROFIT CALCULADO (USD/KG)',
        precioUser: 'PRECIO USUARIO',
        volAcu: 'VOLUMEN ACUERDO',
        cif: 'CIF Price Approx. (USD/Lb)',
        ok: 'OK',
        status: 'ESTADO',
        comments: 'Comentarios',
        comment: 'Comentario',
        addComment: 'Agregar comentario',
        supportFiles: 'Archivos Soporte',
        noSupportFiles: 'No hay archivos disponibles',
        approve: 'Aprobar',
        reject: 'Rechazar',
        approvedOk: 'Aprobado correctamente.',
        rejectedOk: 'Rechazado correctamente.',
        actionError: 'No se pudo confirmar la actualización. Recargue la página para verificar el estado de la RFP antes de reintentar.',
        uploadFile: 'Subir Archivo',
        deleteFile: 'Elminar Archivo',
        uploadedOk: "Archivo subido correctamente.",
        deletedOk: "Archivo eliminado correctamente.",
        filterId: "Buscar por ID",
        filterDist: "Distribuidor",
        filterNameDist: "Nombre Distribuidor",
        filterPlant: "Planta",
        filterStartDate: "Fecha Inicio",
        filterEndDate: "Fecha Fin",
        filterCreationDate: "Fecha de Creación",
        filterState: "Estado",
        filterState1: "Seleccione Estado",
        filterProfit: "Validación Profit",
        filterProfit1: "Seleccione Validación Profit",
        filterClear: "Limpiar Filtros",
        id: "ID",
        commentPlaceholder: "Escribe tu comentario aquí...",
        confirmTitle: "Aprobar o Rechazar",
        confirmNoSelection: "No ha sido marcado ningún checkbox de la lista.",
        confirmQuestion: "¿Desea aprobar / rechazar <strong>todos</strong> los precios?",
        confirmApproveAll: "Aprobar todos",
        confirmRejectAll: "Rechazar todos",
      },
      nuevo_precio: {
        help: 'Ayuda',
        helpText: 'En esta sección podrá enviar los precios acordados para su revisión',
        startDate: 'Fecha Inicio',
        endDate: 'Fecha Fin',
        distribuidor: 'Distribuidor',
        selectPlant: 'Seleccionar Planta',
        selectOption: 'Seleccione una opción',
        selectProduct: 'Seleccionar Producto',
        precioUsdLb: 'Precio (usd/lb)',
        precioUsdCajaLabel: 'Precio (usd/caja)',
        volumenUsdLb: 'Volumen (lb)',
        agregar: 'Agregar',
        condicion_agregar: 'Selecciona solo un producto para agregar',
        condicion_simular: 'No se pueden simular líneas repetidas con el mismo producto, precio y volumen',
        condicion_sku: 'El SKU seleccionado ya fue agregado',
        condicion_planta: 'No se pueden agregar productos de plantas diferentes en la misma RFP',
        precioMode: 'Modo de precio',
        calcular: 'Calcular',
        simulador: 'Simulador',
        flete: 'Flete',
        porLb: 'Por Lb',
        porKg: 'Por Kg',
        primary: 'Primary Carrier',
        incoterm: 'Incoterm',
        invoice: 'Invoice Mode',
        delivery: 'Delivery',
        products: 'Productos',
        select: 'Selecciona',
        planta: 'PLANTA',
        sap: 'CÓDIGO SAP',
        sku: 'SKU',
        precioKg: 'PRECIO (USD/KG)',
        precioUsdCaja: 'PRECIO (USD/CAJA)',
        costoKg: 'COSTO KG',
        costoEnvioKg: 'COSTO ENVÍO KG',
        costoTotalKg: 'COSTO TOTAL KG',
        profitMin: 'PROFIT MÍNIMO (%)',
        profitCalc: 'PROFIT CALCULADO (%)',
        profitCalcUsd: 'PROFIT CALCULADO (USD/KG)',
        volumen: 'VOLUMEN ACUERDO',
        CIFPrice: 'CIF Price Approx. (USD/Lb)',
        eliminar: 'ELIMINAR',
        supportFiles: 'Archivos soporte',
        upFile: 'Subir archivo',
        delFile: 'Eliminar archivo',
        comentarios: 'Comentarios',
        enviar: 'Enviar',
        cancelar: 'Cancelar',
        selectToDelete: 'Seleccione al menos un archivo para eliminar',
        precioCreado: 'Precio creado con éxito',
        precioError: 'Ocurrió un error al crear el precio',
        precioVacio: 'Debe agregar un producto para crear el precio',
        fechaVacia: 'Debe seleccionar fecha de inicio y fecha de fin',
        comentariosVacios: 'Debe agregar un comentario',
      },
      importador: {
        title: 'Importador'
      }
    },
    errors: {
      title: 'Atención!',
      required_field: 'Este campo es obligatorio.',
      invalid_email: 'Por favor, ingrese una dirección de correo electrónico válida.',
      password_mismatch: 'Las contraseñas no coinciden.',
      server_error: 'Ocurrió un error en el servidor. Por favor, inténtelo de nuevo más tarde.',
      not_found: 'El recurso solicitado no fue encontrado (404).',
      forbidden: 'No tienes permiso para acceder a este recurso (403).',
      unknown_error: 'Ocurrió un error desconocido. Por favor, inténtelo de nuevo más tarde.'
    }
  },
  en: {
    global: {
      alert_info_title: 'Information!',
      placeholder_select: 'Select',
      btn_filter: 'Filter',
      btn_clean: 'Clear',
      btn_compute: 'Compute',
      btn_download: 'Download',
      btn_downloading: 'Downloading...',
      btn_search: 'Search',
      btn_searching: 'Searching...',
      btn_save: 'Save',
      btn_cancel: 'Cancel',
      pagination: {
        first: 'First',
        prev: 'Previous',
        next: 'Next',
        last: 'Last',
      }
    },
    header: {
      home: 'Home',
      signOut: 'Sign Out',
      signingOut: 'Signing out ...',
    },
    footer: {
      copyright: 'All rights reserved. Global privacy policy.'
    },
    home: {
      title: 'Services',
      tdc: 'TDC & SWAP Tool',
      pricing_title: 'Pricing'
    },
    tdc: {
      request_number: 'Request Number',
      market: 'Sales Office',
      countries: 'Source',
      sources: 'Source Point',
      divisions: 'Division',
      categories: 'Category',
      subcategories: 'Subcategory',
      families: 'Family',
      formTypes: 'Type',
      sku: 'SKU',
      quantity: 'Quantity (MT)',
      creation_date: 'Creation Date',
      created_by: 'Created by',
      status: 'Status',
      users: 'User',
      icp_kg: 'ICP / KG',
      export_charges: 'Export Charges',
      weight: 'Weight',
      carrier: 'Carrier',
      total_rate: 'Total Rate',
      product_cost_freight: 'Product Cost & Freight',
      porcent_import_duties: '% Import Duties',
      duties: 'Duties',
      in_land_in_country_rate: 'In-Land In Country Rate',
      duties_in_land_in_country: 'Duties and In-land in-country',
      tdc_act: 'TDC',
      comments: 'Comments',
      requests: {
        title: 'Request Consultation',
        create: 'Create New Request',
        approve: 'Approve Request',
        cancel: 'Cancel Request',
      },
      details: {
        title: 'Request Details',
        not_found: 'The requested record was not found.',
      },
      form: {
        title: 'Request Creation',
        subtitle: 'In this section, you can create a new request',
        submitted: 'Your request was successfully registered. You can track its approval status in the "Request Consultation" section.',
        validation: {
          select_single_choice: 'You must select one.',
          select_multiple_choice: 'You must select at least one.',
          required_quantity: 'You must enter a quantity.',
          select_multiple_requests: 'You must select at least one row from the table.',
          required_comments: 'You must add comments.',
        }
      },
      notified: 'The corresponding approval profile has been notified of the status of the request.',
    },
    pricing: {
      mprecios: 'My prices',
      history: {
        title: "Price History",
        help_txt_1: "In this section you can review and download the price history.",
        help_txt_2: "",
        help_txt_3: "",
        id_distribuidor: "Client Id",
        client: "Client",
        plant: "Plant Id",
        plant_name: "Plant",
        sku_id: "Sku Id",
        sku: "Sku",
        start_date: "Date From",
        end_date: "Date To",
        precio_usd_kg: "Price USD/kg",
        precio_usuario: "Price USD/lb",
        precio_usd_caja: "Price USD/caja",
        upload_price_history: "Upload History",
        tooltip: {
          upload_price_history: "Upload Price History File",
        },
        errors: {
          file_fields_match: "Fields does not match",
        },
      },
      competition: {
        title: "Competition Prices",
        help_txt_1: "In this section you can view the prices of the competition.",
        help_txt_2: "Use the filters above to refine your search.", 
        help_txt_3: "You can also upload new competition prices manually.",
        id: "Id",
        market: "Market",
        brand: "Brand",
        product: "Product",
        sku_id: "SKU Id",
        price_case_usd: "Price per Case (USD)",
        price_kg_usd: "Price per Kg (USD)",
        price_pound_usd: "Price per Pound (USD)",
        mccain_product: "McCain Product",
        mccain_description: "McCain Description",
        upload_price: "Upload Prices",
        import_date: "Upload Date",
        category: "Category",
        upload: {
          error_headers: "The headers are invalid. Verify that the header of your Excel file is in the following format (separated by commas):"
        }
      },
      nprecio: 'New price',
      mis_precios: {
        title: 'My Prices',
        subtitle: 'Prices',
        dist: 'Distributor',
        ndist: 'Distributor Name',
        plant: 'Plant',
        startDate: 'Start Date',
        endDate: 'End Date',
        creationDate: 'Creation Date',
        priceCoordApprovalDate: 'Price Coordinator Approval Date',
        vendor: 'Vendor',
        incoterm: 'Incoterm',
        invoice: 'Invoice Mode',
        state: 'Status',
        profit: 'Profit Validation',
        ant: 'Previous',
        sig: 'Next',
        fleteLb: 'Freight per Lb',
        fleteKg: 'Freight per Kg',
        delivery: 'Delivery',
        codSap: 'SAP CODE',
        sku: 'SKU',
        precioUsdKg: 'PRICE (USD/KG)',
        precioUsdCaja: 'PRICE (USD/BOX)',
        costoKg: 'COST KG',
        costoEnvioKg: 'SHIPPING COST KG',
        costoTotalKg: 'TOTAL COST KG',
        profitMin: 'MINIMUM PROFIT (%)',
        profitCal1: 'CALCULATED PROFIT (%)',
        profitCal2: 'CALCULATED PROFIT (USD/KG)',
        precioUser: 'USER PRICE',
        volAcu: 'AGREEMENT VOLUME',
        cif: 'Approx. CIF Price (USD/Lb)',
        ok: 'OK',
        status: 'STATUS',
        comments: 'Comments',
        comment: 'Comment',
        addComment: 'Add comment',
        supportFiles: 'Support Files',
        noSupportFiles: 'No files available',
        approve: 'Approve',
        reject: 'Reject',
        approvedOk: 'Approved successfully.',
        rejectedOk: 'Rejected successfully.',
        actionError: 'The update could not be confirmed. Reload the page to check the RFP status before trying again.',
        uploadFile: 'Upload File',
        deleteFile: 'Delete File',
        uploadedOk: "File uploaded correctly.",
        deletedOk: "File successfully deleted.",
        filterId: "Search by ID",
        filterDist: "Distributor",
        filterNameDist: "Distributor Name",
        filterPlant: "Plant",
        filterStartDate: "Start Date",
        filterEndDate: "End Date",
        filterCreationDate: "Creation Date",
        filterState: "Status",
        filterState1: "Select Status",
        filterProfit: "Profit Validation",
        filterProfit1: "Select Profit Validation",
        filterClear: "Clear Filters",
        id: "ID",
        commentPlaceholder: "Write your comment here...",
        confirmTitle: "Approve or Reject",
        confirmNoSelection: "No checkbox from the list has been checked.",
        confirmQuestion: "Do you want to approve / reject <strong>all</strong> the prices?",
        confirmApproveAll: "Approve all",
        confirmRejectAll: "Reject all",
      },
      nuevo_precio: {
        help: 'Help',
        helpText: 'In this section, you can submit the agreed prices for review',
        startDate: 'Start Date',
        endDate: 'End Date',
        distribuidor: 'Distributor',
        selectPlant: 'Select Plant',
        selectOption: 'Select an option',
        selectProduct: 'Select Product',
        precioUsdLb: 'Price (USD/lb)',
        precioUsdCajaLabel: 'Price (usd/box)',
        volumenUsdLb: 'Volume (lb)',
        agregar: 'Add',
        condicion_agregar: 'Select only one product to add',
        condicion_simular: 'You cannot simulate repeated lines with the same product, price, and volume',
        condicion_sku: 'The selected SKU has already been added',
        condicion_planta: 'Products from different plants cannot be added to the same RFP',
        precioMode: 'Price mode',
        calcular: 'Calculate',
        simulador: 'Simulator',
        flete: 'Freight',
        porLb: 'Per lb',
        porKg: 'Per kg',
        primary: 'Primary Carrier',
        incoterm: 'Incoterm',
        invoice: 'Invoice Mode',
        delivery: 'Delivery',
        products: 'Products',
        select: 'Select',
        planta: 'PLANT',
        sap: 'SAP CODE',
        sku: 'SKU',
        precioKg: 'PRICE (USD/kg)',
        precioUsdCaja: 'PRICE (USD/box)',
        costoKg: 'COST PER KG',
        costoEnvioKg: 'SHIPPING COST PER KG',
        costoTotalKg: 'TOTAL COST PER KG',
        profitMin: 'MINIMUM PROFIT (%)',
        profitCalc: 'CALCULATED PROFIT (%)',
        profitCalcUsd: 'CALCULATED PROFIT (USD/kg)',
        volumen: 'AGREED VOLUME',
        CIFPrice: 'CIF Price Approx. (USD/lb)',
        eliminar: 'DELETE',
        supportFiles: 'Support Files',
        upFile: 'Upload File',
        delFile: 'Delete File',
        comentarios: 'Comments',
        enviar: 'Submit',
        cancelar: 'Cancel',
        selectToDelete: 'Select at least one file to delete',
        precioCreado: 'Price successfully created',
        precioError: 'An error occurred while creating the price',
        precioVacio: 'You must add a product to create the price',
        fechaVacia: 'You must select start date and end date',
        comentariosVacios: 'You must add a comment',
      },      
      importador: {
        title: 'Importer'
      },
    },
    errors: {
      title: 'Attention!',
      required_field: 'This field is required.',
      invalid_email: 'Please enter a valid email address.',
      password_mismatch: 'Passwords do not match.',
      server_error: 'A server error occurred. Please try again later.',
      not_found: 'The requested resource was not found (404).',
      forbidden: 'You are not allowed to access this resource (403).',
      unknown_error: 'An unknown error occurred. Please try again later.'
    }
  },
  pt: {
    global: {
      alert_info_title: 'Información!',
      placeholder_select: 'Selecione',
      btn_filter: 'Filtrar',
      btn_clean: 'Limpar',
      btn_compute: 'Calcular',
      btn_download: 'Baixar',
      btn_downloading: 'Baixando...',
      btn_search: 'Pesquisar',
      btn_searching: 'Pesquisando...',
      btn_save: 'Guardar',
      btn_cancel: 'Cancelar',
      pagination: {
        first: 'Primeiro',
        prev: 'Anterior',
        next: 'Próximo',
        last: 'Último',
      }
    },
    header: {
      home: 'Início',
      signOut: 'Sair',
      signingOut: 'Saindo ...',
    },
    footer: {
      copyright: 'Todos os direitos reservados. Política de privacidade global.'
    },
    home: {
      title: 'Serviços',               // Portuguese translation
      tdc: 'Ferramenta TDC & SWAP',
      pricing_title: 'Preços'
    },
    tdc: {
      request_number: 'Número do Pedido',
      market: 'Sales Office',
      countries: 'Source',
      sources: 'Source Point',
      divisions: 'Divisão',
      categories: 'Categoria',
      subcategories: 'Subcategoria',
      families: 'Família',
      formTypes: 'Tipo',
      sku: 'SKU',
      quantity: 'Quantity (MT)',
      creation_date: 'Data de Criação',
      created_by: 'Creado por',
      status: 'Status',
      users: 'Usuário',
      icp_kg: 'ICP / KG',
      export_charges: 'Export Charges',
      weight: 'Weight',
      carrier: 'Carrier',
      total_rate: 'Total Rate',
      product_cost_freight: 'Product Cost & Freight',
      porcent_import_duties: '% Import Duties',
      duties: 'Duties',
      in_land_in_country_rate: 'In-Land In Country Rate',
      duties_in_land_in_country: 'Duties and In-land in-country',
      tdc_act: 'TDC',
      comments: 'Comentarios',
      requests: {
        title: 'Consulta de Pedidos',
        create: 'Criar Novo Pedido',
        approve: 'Aprovar Pedido',
        cancel: 'Cancelar Pedido',
      },
      details: {
        title: 'Detalhes do Pedido',
        not_found: 'O registro solicitado não foi encontrado.',
      },
      form: {
        title: 'Criação de Pedido',
        subtitle: 'Nesta seção, você pode criar um novo pedido',
        submitted: 'Seu pedido foi registrado com sucesso. Você pode acompanhar o status de aprovação na seção "Consulta de Pedidos".',
        validation: {
          select_single_choice: 'Você deve selecionar um.',
          select_multiple_choice: 'Você deve selecionar pelo menos um.',
          required_quantity: 'Você deve inserir uma quantidade.',
          select_multiple_requests: 'Você deve selecionar pelo menos uma linha da tabela.',
          required_comments: 'Você deve adicionar comentários.',
        }
      },
      notified: 'O perfil de aprovação correspondente foi notificado sobre o status da solicitação.',
    },
    pricing: {
      mprecios: 'Os meus preços',
      history: {
        title: "Histórico de Preços",
        help_txt_1: "Nesta seção, você pode revisar e baixar o histórico de preços.",
        help_txt_2: "",
        help_txt_3: "",
        id_distribuidor: "Id Cliente",
        client: "Cliente",
        plant: "Id Planta",
        plant_name: "Planta",
        sku_id: "Id Sku",
        sku: "Sku",
        start_date: "Data De",
        end_date: "Data Até",
        precio_usd_kg: "Preço USD/kg",
        precio_usuario: "Preço USD/lb",
        precio_usd_caja: "Preço USD/caja",
        upload_price_history: "Carregar Histórico",
        tooltip: {
          upload_price_history: "Carregar Arquivo Histórico de Preços"
        },
        error: {
          file_fields_match: "Os campos do arquivo não correspondem"
        }
      },
      competition: {
        title: "Preços da Concorrência",
        help_txt_1: "Nesta seção você pode visualizar os preços da concorrência.",
        help_txt_2: "Use os filtros acima para refinar sua busca.",
        help_txt_3: "Você também pode carregar novos preços da concorrência manualmente.",
        id: "Id",
        market: "Mercado",
        brand: "Marca",
        product: "Produto",
        sku_id: "ID do SKU",
        price_case_usd: "Preço por Caixa (USD)",
        price_kg_usd: "Preço por Kg (USD)",
        price_pound_usd: "Preço por Libra (USD)",
        mccain_product: "Produto McCain",
        mccain_description: "Descrição McCain",
        upload_price: "Carregar Preços",
        import_date: "Data de Carga",
        category: "Categoria",
        upload: {
          error_headers: "Os cabeçalhos são inválidos. Verifique se o cabeçalho do seu arquivo Excel está no seguinte formato (separado por vírgulas):"
        }
      },
      nprecio: 'Novo preço',
      mis_precios: {
        title: 'Meus Preços',
        subtitle: 'Preços',
        dist: 'Distribuidor',
        ndist: 'Nome do Distribuidor',
        plant: 'Planta',
        startDate: 'Data de Início',
        endDate: 'Data de Término',
        creationDate: 'Data de Criação',
        priceCoordApprovalDate: 'Data de Aprovação do Price Coordinator',
        vendor: 'Vendedor',
        incoterm: 'Incoterm',
        invoice: 'Modo de Fatura',
        state: 'Estado',
        profit: 'Validação de Lucro',
        ant: 'Anterior',
        sig: 'Próximo',
        fleteLb: 'Frete por Lb',
        fleteKg: 'Frete por Kg',
        delivery: 'Entrega',
        codSap: 'CÓDIGO SAP',
        sku: 'SKU',
        precioUsdKg: 'PREÇO (USD/KG)',
        precioUsdCaja: 'PREÇO (USD/CAIXA)',
        costoKg: 'CUSTO KG',
        costoEnvioKg: 'CUSTO DE ENVIO KG',
        costoTotalKg: 'CUSTO TOTAL KG',
        profitMin: 'LUCRO MÍNIMO (%)',
        profitCal1: 'LUCRO CALCULADO (%)',
        profitCal2: 'LUCRO CALCULADO (USD/KG)',
        precioUser: 'PREÇO DO USUÁRIO',
        volAcu: 'VOLUME DO ACORDO',
        cif: 'Preço CIF Aprox. (USD/Lb)',
        ok: 'OK',
        status: 'ESTADO',
        comments: 'Comentários',
        comment: 'Comentário',
        addComment: 'Adicionar comentário',
        supportFiles: 'Arquivos de Suporte',
        noSupportFiles: 'Nenhum arquivo disponível',
        approve: 'Aprovar',
        reject: 'Rejeitar',
        approvedOk: 'Aprovado com sucesso.',
        rejectedOk: 'Rejeitado com sucesso.',
        actionError: 'Não foi possível confirmar a atualização. Recarregue a página para verificar o status da RFP antes de tentar novamente.',
        uploadFile: 'Carregar Arquivo',
        deleteFile: 'Excluir Arquivo',
        uploadedOk: "Arquivo carregado corretamente.",
        deletedOk: "Arquivo excluído com sucesso.",
        filterId: "Buscar por ID",
        filterDist: "Distribuidor",
        filterNameDist: "Nome do Distribuidor",
        filterPlant: "Planta",
        filterStartDate: "Data de Início",
        filterEndDate: "Data Final",
        filterCreationDate: "Data de Criação",
        filterState: "Estado",
        filterState1: "Selecione o Estado",
        filterProfit: "Validação do Lucro",
        filterProfit1: "Selecione a Validação do Lucro",
        filterClear: "Limpar Filtros",
        id: "ID",
        commentPlaceholder: "Escreva seu comentário aqui...",
        confirmTitle: "Aprovar ou Rejeitar",
        confirmNoSelection: "Nenhuma caixa de seleção da lista foi marcada.",
        confirmQuestion: "Deseja aprovar / rejeitar <strong>todos</strong> os preços?",
        confirmApproveAll: "Aprovar todos",
        confirmRejectAll: "Rejeitar todos",
      },
      nuevo_precio: {
        help: 'Ajuda',
        helpText: 'Nesta seção, você pode enviar os preços acordados para revisão',
        startDate: 'Data de Início',
        endDate: 'Data de Término',
        distribuidor: 'Distribuidor',
        selectPlant: 'Selecionar Planta',
        selectOption: 'Selecione uma opção',
        selectProduct: 'Selecionar Produto',
        precioUsdLb: 'Preço (USD/lb)',
        precioUsdCajaLabel: 'Preço (usd/caixa)',
        volumenUsdLb: 'Volume (lb)',
        agregar: 'Adicionar',
        condicion_agregar: 'Selecione apenas um produto para adicionar',
        condicion_simular: 'Não é possível simular linhas repetidas com o mesmo produto, preço e volume',
        condicion_sku: 'O SKU selecionado já foi adicionado',
        condicion_planta: 'Não é possível adicionar produtos de plantas diferentes na mesma RFP',
        precioMode: 'Modo de preço',
        calcular: 'Calcular',
        simulador: 'Simulador',
        flete: 'Frete',
        porLb: 'Por lb',
        porKg: 'Por kg',
        primary: 'Transportadora Principal',
        incoterm: 'Incoterm',
        invoice: 'Modo de Faturamento',
        delivery: 'Entrega',
        products: 'Produtos',
        select: 'Selecione',
        planta: 'PLANTA',
        sap: 'CÓDIGO SAP',
        sku: 'SKU',
        precioKg: 'PREÇO (USD/kg)',
        precioUsdCaja: 'PREÇO (USD/caixa)',
        costoKg: 'CUSTO POR KG',
        costoEnvioKg: 'CUSTO DE ENVIO POR KG',
        costoTotalKg: 'CUSTO TOTAL POR KG',
        profitMin: 'LUCRO MÍNIMO (%)',
        profitCalc: 'LUCRO CALCULADO (%)',
        profitCalcUsd: 'LUCRO CALCULADO (USD/kg)',
        volumen: 'VOLUME ACORDADO',
        CIFPrice: 'Preço CIF Aproximado (USD/lb)',
        eliminar: 'EXCLUIR',
        supportFiles: 'Arquivos de Suporte',
        upFile: 'Carregar Arquivo',
        delFile: 'Excluir Arquivo',
        comentarios: 'Comentários',
        enviar: 'Enviar',
        cancelar: 'Cancelar',
        selectToDelete: 'Selecione pelo menos um arquivo para excluir',
        precioCreado: 'Preço criado com sucesso',
        precioError: 'Ocorreu um erro ao criar o preço',
        precioVacio: 'Você deve adicionar um produto para criar o preço',
        fechaVacia: 'Você deve selecionar a data de início e a data de término',
        comentariosVacios: 'Você deve adicionar um comentário',
      },      
      importador: {
        title: 'Importador'
      },
    },
    errors: {
      title: 'Atención!',
      required_field: 'Este campo é obrigatório.',
      invalid_email: 'Por favor, insira um endereço de email válido.',
      password_mismatch: 'As senhas não correspondem.',
      server_error: 'Ocorreu um erro no servidor. Tente novamente mais tarde.',
      not_found: 'O recurso solicitado não foi encontrado (404).',
      forbidden: 'Você não tem permissão para acessar este recurso (403).',
      unknown_error: 'Ocorreu um erro desconhecido. Tente novamente mais tarde.'
    }
  },
};

let locale = '';
const defaultLocale = window.$cookies.get('mccain_service_user_language') || 'es';
switch (defaultLocale.toString().toLowerCase()) {
  case 'portuguese':
  case 'pt':
    locale = 'pt';
    break;
  case 'english':
  case 'en':
    locale = 'en';
    break;
  case 'spanish':
  case 'es':
  default:
    locale = 'es';
    break;
}

const i18n = createI18n({
  legacy: false,
  locale: locale, // set locale from cookies
  fallbackLocale: 'es', // fallback locale
  messages, // set locale messages
});

export default i18n;
